// Auto Generated file, do not modify
import {
    apiDelete,
    apiGet,
    apiPost,
    apiPut,
    ApiRequestOptions,
} from "@redriver/cinnamon-mui";
import {
    CompleteActionRequest,
    CreateActionRequest,
    UpdateActionRequest,
} from "mortar/EnergyEngineering/Endpoints/Actions";
import {
    CreateActionRemarkRequest,
    UpdateActionRemarkRequest,
} from "mortar/EnergyEngineering/Endpoints/Actions/Remarks";
import { ActionPriority, ActionStatus } from "mortar/EnergyEngineering/Enums";
import {
    ActionListView,
    ActionRemarkListView,
    ActionView,
} from "mortar/EnergyEngineering/Logic/Actions/Views";
import { PagedView } from "mortar/EnergyEngineering/Logic/Views";
import { makeAction, makeFormData } from "../lib";

export interface ListActionsQueryParams {
    pageSize: number;
    pageNumber: number;
    search: string;
    includeAllActions: boolean;
    includeAssigned: boolean;
    includeCreated: boolean;
    statuses: ActionStatus[];
    priorities: ActionPriority[];
    userIds: string[];
    jobId: string;
}

export interface ListActionsActionRequest {
    queryParams: ListActionsQueryParams;
    options?: Partial<
        ApiRequestOptions<PagedView<ActionListView>, "actions/listActions">
    >;
}

export const listActions = makeAction((
    { queryParams, options }: ListActionsActionRequest,
) => apiGet<PagedView<ActionListView>, "actions/listActions">(
    "actions/listActions",
    `actions`,
    queryParams,
    options,
), "actions/listActions");

export interface CreateActionActionRequest {
    request: CreateActionRequest;
    options?: Partial<ApiRequestOptions<string, "actions/createAction">>;
}

export const createAction = makeAction((
    { request, options }: CreateActionActionRequest,
) => apiPost<string, "actions/createAction">(
    "actions/createAction",
    `actions`,
    request,
    options,
), "actions/createAction");

export interface GetActionRouteParams {
    actionId: string;
}

export interface GetActionActionRequest {
    routeParams: GetActionRouteParams;
    options?: Partial<ApiRequestOptions<ActionView, "actions/getAction">>;
}

export const getAction = makeAction((
    { routeParams, options }: GetActionActionRequest,
) => apiGet<ActionView, "actions/getAction">(
    "actions/getAction",
    `actions/${routeParams.actionId}`,
    undefined,
    options,
), "actions/getAction");

export interface UpdateActionRouteParams {
    actionId: string;
}

export interface UpdateActionActionRequest {
    routeParams: UpdateActionRouteParams;
    request: UpdateActionRequest;
    options?: Partial<ApiRequestOptions<void, "actions/updateAction">>;
}

export const updateAction = makeAction((
    { routeParams, request, options }: UpdateActionActionRequest,
) => apiPost<void, "actions/updateAction">(
    "actions/updateAction",
    `actions/${routeParams.actionId}`,
    request,
    options,
), "actions/updateAction");

export interface CompleteActionRouteParams {
    actionId: string;
}

export interface CompleteActionActionRequest {
    routeParams: CompleteActionRouteParams;
    request: CompleteActionRequest;
    options?: Partial<ApiRequestOptions<void, "actions/completeAction">>;
}

export const completeAction = makeAction((
    { routeParams, request, options }: CompleteActionActionRequest,
) => apiPost<void, "actions/completeAction">(
    "actions/completeAction",
    `actions/${routeParams.actionId}/complete`,
    request,
    options,
), "actions/completeAction");

export interface ListActionRemarksRouteParams {
    actionId: string;
}

export interface ListActionRemarksActionRequest {
    routeParams: ListActionRemarksRouteParams;
    options?: Partial<
        ApiRequestOptions<ActionRemarkListView[], "actions/listActionRemarks">
    >;
}

export const listActionRemarks = makeAction((
    { routeParams, options }: ListActionRemarksActionRequest,
) => apiGet<ActionRemarkListView[], "actions/listActionRemarks">(
    "actions/listActionRemarks",
    `actions/${routeParams.actionId}/remarks`,
    undefined,
    options,
), "actions/listActionRemarks");

export interface CreateActionRemarkRouteParams {
    actionId: string;
}

export interface CreateActionRemarkActionRequest {
    routeParams: CreateActionRemarkRouteParams;
    request: CreateActionRemarkRequest;
    options?: Partial<ApiRequestOptions<void, "actions/createActionRemark">>;
}

export const createActionRemark = makeAction((
    { routeParams, request, options }: CreateActionRemarkActionRequest,
) => apiPost<void, "actions/createActionRemark">(
    "actions/createActionRemark",
    `actions/${routeParams.actionId}/remarks`,
    request,
    options,
), "actions/createActionRemark");

export interface UpdateActionRemarkRouteParams {
    actionId: string;
    remarkId: string;
}

export interface UpdateActionRemarkActionRequest {
    routeParams: UpdateActionRemarkRouteParams;
    request: UpdateActionRemarkRequest;
    options?: Partial<ApiRequestOptions<void, "actions/updateActionRemark">>;
}

export const updateActionRemark = makeAction((
    { routeParams, request, options }: UpdateActionRemarkActionRequest,
) => apiPut<void, "actions/updateActionRemark">(
    "actions/updateActionRemark",
    `actions/${routeParams.actionId}/remarks/${routeParams.remarkId}`,
    request,
    options,
), "actions/updateActionRemark");

export interface DeleteActionRemarkRouteParams {
    actionId: string;
    remarkId: string;
}

export interface DeleteActionRemarkActionRequest {
    routeParams: DeleteActionRemarkRouteParams;
    options?: Partial<ApiRequestOptions<void, "actions/deleteActionRemark">>;
}

export const deleteActionRemark = makeAction((
    { routeParams, options }: DeleteActionRemarkActionRequest,
) => apiDelete<void, "actions/deleteActionRemark">(
    "actions/deleteActionRemark",
    `actions/${routeParams.actionId}/remarks/${routeParams.remarkId}`,
    undefined,
    options,
), "actions/deleteActionRemark");
